import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WalletMembershipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wallet_membership"}/>
}
